import { useEffect, useState } from "react";
import classNames from "classnames";
import { showLoading } from "../../utils";

import ss from "./report.module.css";

export const ReportPage = () => {
  const session_uuid = new URLSearchParams(window.location.search).get("sid");
  const [photoList, setPhotoList] = useState([]);

  useEffect(() => {
    const loading = showLoading("加载中");
    fetch(
      `https://wanpilaoban-1314240291.cos.ap-beijing.myqcloud.com/outdoor/report/${session_uuid}.json`
    )
      .then((res) => {
        res.json().then((data) => {
          setPhotoList(data || []);
        });
      })
      .finally(() => loading.hide());
  }, []);

  return (
    <div className={ss.teamCard}>
      <div className={ss.teamHeader}>
        <div className={ss.hint}>长按照片可保存，战报有效期30天</div>
      </div>
      <div className={classNames(ss.photoList, ss.active)}>
        {photoList.map((photo) => (
          <div key={photo.id} className={ss.photo}>
            <img className={ss.photoImg} src={photo.photo} />
          </div>
        ))}
      </div>
    </div>
  );
};
